/**
 * Function to update hero title & subtitle. Used in QS White Label sites.
 * @param {Object} headerData - Map of `data-step-name` to `{ headline, p }`, plus a required
 * `default` entry used as the fallback for unlisted steps. Every entry must declare the same
 * fields: a site may manage only `p`, only `headline`, or both, but mixing them across entries
 * leaves the previous step's copy on screen. A declared field is always written, so `''` clears.
 * @returns {void}
 */
export default function customHeader(headerData) {
	if (!headerData) {
		return;
	}

	const getVars = window.modForm?.opts?.getVars;
	const hasDynamicTitleOrSubtitle = getVars && (getVars.title || getVars.subtitle);
	const heroTitle = document.querySelector('.hero__title');
	const heroSubTitle = document.querySelector('.hero__subtitle');
	const fallbackDataStepName = 'default';
	const zipStepName = 'zip';
	const stepName = window.modForm?.opts?.form?.querySelector('.step--active')?.getAttribute('data-step-name');

	// condition to update dynamic hero title & subtitle only on first step
	if (hasDynamicTitleOrSubtitle && stepName === zipStepName) {
		window.modForm?.initFormDynamicContent();
		return;
	}

	const resolvedStepName = headerData[stepName] ? stepName : fallbackDataStepName;
	const stepData = headerData[resolvedStepName];

	if (!stepData) {
		console.warn(`[mod-utils] customHeader: no headerData entry for step "${stepName}" and no "${fallbackDataStepName}" fallback declared.`);
		return;
	}

	// an entry that omits a field its siblings declare leaves the previous step's copy on screen
	['headline', 'p'].forEach((field) => {
		const isDeclaredElsewhere = Object.keys(headerData).some((key) => {
			return headerData[key] && Object.prototype.hasOwnProperty.call(headerData[key], field);
		});

		if (isDeclaredElsewhere && !Object.prototype.hasOwnProperty.call(stepData, field)) {
			console.warn(`[mod-utils] customHeader: headerData entry "${resolvedStepName}" is missing "${field}" declared by other entries.`);
		}
	});

	if (heroTitle && stepData.headline != null) {
		heroTitle.innerHTML = stepData.headline;
		const userLocation = heroTitle.querySelector('.user-location');
		if (userLocation) {
			userLocation.innerHTML = window.modForm?.opts?.userLocation;
		}
	}

	if (heroSubTitle && stepData.p != null) {
		heroSubTitle.innerHTML = stepData.p;
	}
}
